import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent } from '@beyonnex/bx-angular-ui';
import { StatusBadgeComponent } from '../../../../components/status-badge/status-badge.component';
import { AttributesPanelData } from './attributes-panel.models';

@Component({
  selector: 'bxi-attributes-panel',
  imports: [SvgIconComponent, StatusBadgeComponent],
  templateUrl: './attributes-panel.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttributesPanelComponent {
  data = input.required<AttributesPanelData>();
}
